<template>
  <v-chart class="chart" :option="options" :autoresize="true" />
</template>

<script>
import http from "@/api/http";
import { defineComponent, ref, onMounted } from "vue";
import * as echarts from "echarts";
import { useStore } from "vuex";
export default defineComponent({
  name: "DianFei",
  components: {},
  props: {},
  setup() {
    var getname = [
      "10-01",
      "10-02",
      "10-03",
      "10-04",
      "10-05",
      "10-06",
      "10-07",
      "10-08",
      "10-09",
      "10-10",
      "10-11",
      "10-12",
    ];
    var getvalue = [55, 46, 30, 23, 55, 46, 30, 23, 55, 46, 30, 23];
    const options = ref({
      grid: {
        top: "12%",
        right: "4%",
        left: "10%",
        bottom: "15%",
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
      },
      xAxis: [
        {
          type: "category",
          color: "#59588D",
          data: getname,
          axisLabel: {
            interval: 0,
            rotate: 0,
            margin: 10,
            color: "#ccc",
            textStyle: {
              fontSize: 12,
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(49,218,255,0.5)",
            },
          },
          axisTick: {
            show: false,
          },
        },
      ],
      yAxis: [
        {
          //name: "单位:元",
          nameTextStyle: {
            color: "#B6E7FF",
          },
          //min: 0,
          //max: 100,
          axisLabel: {
            formatter: "{value}",
            color: "#ccc",
            textStyle: {
              fontSize: 12,
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#ccc",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "rgba(49,218,255,0.5)",
              type: "dashed",
            },
          },
        },
      ],
      series: [
        {
          type: "bar",
          data: getvalue,
          barWidth: "12px",
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "#2489ff", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#2489ff", // 100% 处的颜色
                  },
                ],
                false
              ),
              barBorderRadius: [0, 0, 0, 0],
            },
          },
        },
      ],
    });
    const store = useStore()
    let stationid = store.getters['User/stationid']
    const getData = () => {
      http.get("/base_station/" + stationid + "/charge-discharge/month").then((res) => {
        console.log('000', res)

      });
    };
    onMounted(() => {
      //组件挂载时的生命周期执行的方法
      getData()
    });

    return {
      options,
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
